import { Component, HostBinding } from "@angular/core";

@Component({
	standalone: false,
	selector: "ay-page-title",
	template: "<ng-content></ng-content>",
})
export class AyPageTitleComponent {
	constructor() {}
	@HostBinding("class") class = "py-6";
}
